import { BetSlipMode, PlaceBetValidationError } from "../../types/enums";

export function classifyPlaceBetError({
  mode,
  totalStake,
  individualStakeValues,
  totalSelections,
  isBooking,
  isFreeBet,
  user,
  brand,
}: PlaceBetValidationInput): PlaceBetValidationError {
  if (isBooking) return PlaceBetValidationError.None;
  if (user.isLocked) return PlaceBetValidationError.UserLocked;
  if (brand.selectionsLimit > 0 && totalSelections > brand.selectionsLimit)
    return PlaceBetValidationError.MaxSelectionsExceeded;
  if (mode === BetSlipMode.Combo && totalStake === 0)
    return PlaceBetValidationError.StakeNotMetCombo;
  if (!isFreeBet && mode === BetSlipMode.Single && individualStakeValues.some((s) => !s))
    return PlaceBetValidationError.StakeNotMetSingle;
  if (!isFreeBet && totalStake < user.minBet)
    return PlaceBetValidationError.StakeBelowMin;
  if (!isFreeBet && totalStake >= user.maxBet)
    return PlaceBetValidationError.StakeAboveMax;
  if (!isFreeBet && user.balance === 0)
    return PlaceBetValidationError.NoBalance;
  if (!isFreeBet && user.balance < totalStake)
    return PlaceBetValidationError.InsufficientBalance;
  return PlaceBetValidationError.None;
}

export function getValidationErrorKey(
  error: PlaceBetValidationError,
): keyof TranslationKeys | null {
  switch (error) {
    case PlaceBetValidationError.UserLocked:
      return "LockedUserCannotPlaceBet";
    case PlaceBetValidationError.MaxSelectionsExceeded:
      return "BetslipMaxSelections";
    case PlaceBetValidationError.StakeNotMetCombo:
      return "BetSlipStakeAmountVsAmountNotMetCombo";
    case PlaceBetValidationError.StakeNotMetSingle:
      return "BetSlipStakeAmountVsAmountNotMetSingle";
    case PlaceBetValidationError.StakeBelowMin:
      return "BetSlipStakeAmountVsLowerThanAllowedAmount";
    case PlaceBetValidationError.StakeAboveMax:
      return "BetSlipStakeAmountVsGreaterThanAllowedAmount";
    default:
      return null;
  }
}

export function getModalValidationErrorKey(
  error: PlaceBetValidationError,
): PlaceBetModalErrorKey | null {
  switch (error) {
    case PlaceBetValidationError.NoBalance:
      return "BetSlipStakeErrorPopup";
    case PlaceBetValidationError.InsufficientBalance:
      return "BetSlipStakeErrorPopupNoEnoughMoney-popup";
    default:
      return null;
  }
}

export function getModalTitleKey(
  messageKey: PlaceBetModalErrorKey,
): keyof TranslationKeys | null {
  switch (messageKey) {
    case "BetSlipStakeErrorPopupNoEnoughMoney-popup":
      return "BetSlipStakeErrorPopupNoEnoughMoneytitle";
    default:
      return null;
  }
}
